import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BgcForm from "./Components/BgcForm";
import './App.css'


function App() {
  return (
    <div>
      <Router>
        <Routes>
          {/* <Route path="/" element={<ResidentalVerification />} /> */}
          <Route path="/" element={<BgcForm/>}/>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
